import { Injectable } from '@angular/core';
import { Localizable } from '@app/shared/models/localizable/localizable';
import { EntityProviderStoreExtensionService } from '@app/shared/services/entity-provider-store-extension.service';
import { EntityAwareServiceClass, EntityFactoryService } from '@technocom/data';
import { LocalizableFactoryService } from '@app/shared/models/localizable/localizable-factory-service';

@Injectable({
  providedIn: 'root',
})
export class LocalizableProviderStoreService<T extends Localizable = any> extends EntityProviderStoreExtensionService {
  protected readonly type = Localizable;

  protected getFactory(): EntityAwareServiceClass<EntityFactoryService> {
    return LocalizableFactoryService;
  }
}
